import Swiper from 'swiper/bundle';

export default {
    name : 'products-slideshow',

    init()
    {
        this.run();
    },
    run ()
    {
        const slideshow = '.product-slideshow';
        const swiperItems = document.querySelectorAll(`${slideshow} .swiper-slide`);

        const swiper = new Swiper(slideshow, {
            clickable : true,
            navigation: {
              nextEl: `${slideshow} .swiper-button-next`,
              prevEl: `${slideshow} .swiper-button-prev`,
            },
            pagination: {
              el: `${slideshow} .swiper-pagination`,
            },
            slidesPerView: 1,
            spaceBetween: 10,
            breakpoints: {
                480: {
                  slidesPerView: 2,
                  spaceBetween: 20
                },
                1200: {
                  slidesPerView: 4,
                  spaceBetween: 20
                }
            }
        });

        if (swiperItems.length > 1) {
            document.querySelector(slideshow).classList.add("show-ux");
        }
    }
}